import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Professores from './components/Professores';
import Disciplinas from './components/Disciplinas';
import Laboratorios from './components/Laboratorios';
import Periodos from './components/Periodos';
import Configuracoes from './components/Configuracoes';
import Agendas from './components/Agendas';
import Grades from './components/Grades';
import Relatorios from './components/Relatorios';
import GradeViewPage from './pages/GradeViewPage';
import GradeLaboratorioViewPage from './pages/GradeLaboratorioViewPage';
import AgendaLaboratorioPage from './pages/AgendaLaboratorioPage';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    
    if (token) {
      try {
        // Validação básica do formato JWT (deve ter 3 partes separadas por pontos)
        const parts = token.split('.');
        
        if (parts.length === 3) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('authToken');
          setIsAuthenticated(false);
        }
      } catch (error) {
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token: string, nome: string) => {
    localStorage.setItem('authToken', token);
    if (nome) {
      localStorage.setItem('userName', nome);
    }
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userName');
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="App">
        {isAuthenticated && <Navbar onLogout={handleLogout} />}
        <Routes>
          <Route 
            path="/login" 
            element={
              !isAuthenticated ? 
                <Login onLogin={handleLogin} /> : 
                <Navigate to="/dashboard" replace />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
                <Dashboard /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/professores" 
            element={
              isAuthenticated ? 
                <Professores /> : 
                <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/disciplinas" 
            element={
              isAuthenticated ? 
                <Disciplinas /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/laboratorios" 
            element={
              isAuthenticated ? 
                <Laboratorios /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/periodos" 
            element={
              isAuthenticated ? 
                <Periodos /> : 
                <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/agendas" 
            element={
              isAuthenticated ? 
                <Agendas /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/grades" 
            element={
              isAuthenticated ? 
                <Grades /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/grades/view/:gradeId" 
            element={
              isAuthenticated ? 
                <GradeViewPage /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/grade-laboratorio/:gradeId" 
            element={
              isAuthenticated ? 
                <GradeLaboratorioViewPage /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/agenda-laboratorio/:laboratorioId/:agendaId" 
            element={
              isAuthenticated ? 
                <AgendaLaboratorioPage /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/relatorios" 
            element={
              isAuthenticated ? 
                <Relatorios /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/configuracoes" 
            element={
              isAuthenticated ? 
                <Configuracoes /> : 
                <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/" 
            element={
              <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;